package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.ReleaseLockResult
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class ReleaseLockUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String): ReleaseLockResult = repo.releaseLock(ticketId)
}
